// extracted by mini-css-extract-plugin
export default {"root":"footer_root__+G5N7","title":"footer_title__8m9uy","logo":"footer_logo__U5QbN","p":"footer_p__gHPdJ"};